export const CookieKey = {
  CsrfToken: 'csrftoken',
  AuthToken: 'a_t',
  WalkerIdentifier: 'w_id',
};
